import React from "react";
import { useTabContext } from "../context/context";
import { useFormContext } from "react-hook-form";

const Accepting = () => {
  const { notAccepting, setNotAccepting } = useTabContext();
  const { register } = useFormContext();

  const notAcceptingReasons = [
    { value: "Due to Coronavirus", label: "Due to Coronavirus" },
    { value: "Due to natural disaster", label: "Due to natural disaster" },
    { value: "Waitlist only - no vacancy", label: "Waitlist only - no vacancy" },
    { value: "Coming soon, under development", label: "Coming soon, under development" },
    { value: "Reason not specified", label: "Reason not specified" }
  ];

  return (
    <div className="provider-section">
      <h3>Current Availability Status</h3>
      <div className="my-2 border-gray-300  flex items-center h-[30px]">
        <div>
          <span className="font-semibold">Not Currently Accepting new residents / clients</span>
          <input
            type="checkbox"
            name="not_accepting"
            id="not_accepting"
            {...register("not_accepting")}
            className="ml-2"
            onChange={e => {
              setNotAccepting(e.target.checked ? true : false);
            }}
          />
        </div>
        <div className="ml-2">
          {notAccepting && (
            <select {...register("not_accepting_reason")}>
              <option value="">Select Reason</option>
              {notAcceptingReasons.map((reason, index) => (
                <option key={index} value={reason.value}>
                  {reason.label}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
    </div>
  );
};

export default Accepting;
